// @flow

import { getConfiguratorSettings } from './main';

import type { State } from '../reducers';

type GlobalState = {
  configuratorSettings: State,
};

type Cart = $PropertyType<State, 'cart'>;
type CartButtons = $PropertyType<Cart, 'buttons'>;

export const getCartSettings = (state: GlobalState): Cart => {
  const cartSettings = getConfiguratorSettings(state).cart;
  if (!cartSettings) {
    throw new Error('Missing cart settings in configuratorSettings store.');
  }
  return cartSettings;
};

type PackageLabel = $PropertyType<Cart, 'package_label'>;
export const getPackageLabel = (state: GlobalState): PackageLabel => (
  getCartSettings(state).package_label
);

type ColorLabel = $PropertyType<Cart, 'color_label'>;
export const getColorLabel = (state: GlobalState): ColorLabel => (
  getCartSettings(state).color_label
);

type ClaimFreeLabel = $PropertyType<Cart, 'claim_free_label'>;
export const getClaimFreeLabel = (state: GlobalState): ClaimFreeLabel => (
  getCartSettings(state).claim_free_label
);

type DeliveryTimeLabel = $PropertyType<Cart, 'delivery_time_label'>;
export const getDeliveryTimeLabel = (state: GlobalState): DeliveryTimeLabel => (
  getCartSettings(state).delivery_time_label
);

type DurationLabel = $PropertyType<Cart, 'duration_label'>;
export const getDurationLabel = (state: GlobalState): DurationLabel => (
  getCartSettings(state).duration_label
);

type MileageLabel = $PropertyType<Cart, 'mileage_label'>;
export const getMileageLabel = (state: GlobalState): MileageLabel => (
  getCartSettings(state).mileage_label
);

type BundleLabel = $PropertyType<Cart, 'bundle_label'>;
export const getBundleLabel = (state: GlobalState): BundleLabel => (
  getCartSettings(state).bundle_label
);

type ExtraLabel = $PropertyType<Cart, 'extra_label'>;
export const getExtraLabel = (state: GlobalState): ExtraLabel => (
  getCartSettings(state).extra_label
);

type InsurancesLabel = $PropertyType<Cart, 'insurance_label'>;
export const getInsurancesLabel = (state: GlobalState): InsurancesLabel => (
  getCartSettings(state).insurance_label
);

type PricePerMonthLabel = $PropertyType<Cart, 'price_per_month_label'>;
export const getPricePerMonthLabel = (state: GlobalState): PricePerMonthLabel => (
  getCartSettings(state).price_per_month_label
);

type ModelLabel = $PropertyType<Cart, 'model_label'>;
export const getModelLabel = (state: GlobalState): ModelLabel => (
  getCartSettings(state).model_label
);

type TaxNoteLabel = $PropertyType<Cart, 'tax_note'>;
export const getTaxNote = (state: GlobalState): TaxNoteLabel => (
  getCartSettings(state).tax_note
);

type PerText = $PropertyType<Cart, 'per'>;
export const getPerText = (state: GlobalState): PerText => (
  getCartSettings(state).per
);

type MonthText = $PropertyType<Cart, 'month'>;
export const getMonthText = (state: GlobalState): MonthText => (
  getCartSettings(state).month
);

type YearText = $PropertyType<Cart, 'year'>;
export const getYearText = (state: GlobalState): YearText => (
  getCartSettings(state).year
);

type PerMonthAbbrv = $PropertyType<Cart, 'per_month_abbrv'>;
export const getPerMonthAbbrv = (state: GlobalState): PerMonthAbbrv => (
  getCartSettings(state).per_month_abbrv
);

type RoadTaxNoteLabel = $PropertyType<Cart, 'roadtax_note'>;
export const getRoadTaxNote = (state: GlobalState): RoadTaxNoteLabel => (
  getCartSettings(state).roadtax_note
);

type IncludingAbbreviation = $PropertyType<Cart, 'including_abbreviation'>;
export const getIncludingAbbreviation = (state: GlobalState): IncludingAbbreviation => (
  getCartSettings(state).including_abbreviation
);

type CartHeader = $PropertyType<Cart, 'cart_header'>;
export const getCartHeader = (state: GlobalState): CartHeader => (
  getCartSettings(state).cart_header
);

type MailOfferButtonText = $PropertyType<CartButtons, 'mail_offer'>;
export const getMailOfferButtonText = (state: GlobalState): MailOfferButtonText => (
  getCartSettings(state).buttons.mail_offer
);

type OrderLeaseObjectButtonText = $PropertyType<CartButtons, 'order_lease_object'>;
export const getOrderLeaseObjectButtonText = (state: GlobalState): OrderLeaseObjectButtonText => (
  getCartSettings(state).buttons.order_lease_object
);

type CloseButtonText = $PropertyType<CartButtons, 'close'>;
export const getCloseButtonText = (state: GlobalState): CloseButtonText => (
  getCartSettings(state).buttons.close
);

export default null;
